import React, { useState } from 'react';
import ContactSection  from '../components/ContactSection';

const Contact: React.FC = () => {
  const [formData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission here
    console.log('Form submitted:', formData);
  };


  return (
    <div >
      <ContactSection handleSubmit={handleSubmit} topMargin="py-[6rem]" />
    </div>
  );
};

export default Contact;
